import { render, staticRenderFns } from "./StepBookingTypesPreSelection.vue?vue&type=template&id=2af22ddf&"
import script from "./StepBookingTypesPreSelection.vue?vue&type=script&lang=js&"
export * from "./StepBookingTypesPreSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports